import { z } from 'zod';

export const DashboardQuerySchema = z.object({
  fiscalYear: z.coerce.number().int().optional(),
  month: z.coerce.number().int().min(1).max(12).optional(),
  scope: z.string().optional(),
});
export type DashboardQuery = z.infer<typeof DashboardQuerySchema>;

export const KpiSchema = z.object({
  key: z.string(),
  label: z.string(),
  value: z.union([z.string(), z.number()]),
  sub: z.string(),
});
export type Kpi = z.infer<typeof KpiSchema>;
